import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { InvestigationFormRepository } from '../../../infrastructure/repositories/investigation-form.repository';
import { CreateInvestigationFormCommand } from './create-investigation-form.command';

@Injectable({ providedIn: 'root' })
export class CreateInvestigationFormUseCase {
  private readonly _repository = inject(InvestigationFormRepository);

  public execute(command: CreateInvestigationFormCommand): Observable<{ formId: string; versionId: string }> {
    return this._repository.createInvestigationForm(command);
  }
}
